module.exports = __webpack_public_path__ + "static/media/market.ecfd6973.svg";